import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axiosInstance from '../../utils/axiosSetup.js';
import DeleteComponent from '../../action/delete.jsx';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import toast from 'react-hot-toast';
import EditTimeLog from './sections/edit.jsx';
import { convertTimeToDecimal } from '../../action/timeCalculation.jsx';

const TimeLog = () => {
    const [timelogs, setTimeLogs] = useState([]);
    const [timelogId, setTimeLogId] = useState(null);
    const [totalTime, setTotalTime] = useState(0);

    const fetchTimeLogs = async () => {
        try {
            const response = await axiosInstance.get(`${process.env.REACT_APP_API_URL}/get_user_timelogs`);
            const jsonData = response.data.data;
            setTimeLogs(jsonData);

            const result = jsonData.reduce((total, timelog) => {
                const time = timelog.deleted_at ? '00:00' : timelog.total_time_spend;
                return total + convertTimeToDecimal(time);
            }, 0);
            setTotalTime(result);
        } catch (error) {
            console.error("Error fetching time logs!", error);
            setTimeLogs([]);
            setTotalTime(0);
        }
    };

    useEffect(() => {
        fetchTimeLogs();
    }, []);

    // VALIDATION RULES
    const schema = Yup.object().shape({        
        is_submitted: Yup.bool().oneOf([true], "please check the option"),
    });

    const { register, handleSubmit, formState: { errors }, reset } = useForm({
        mode: 'all',
        resolver: yupResolver(schema)
    });

    const onSubmit = async (data) => {
        if(totalTime < parseFloat(8)){
            alert('The total time logged must be 8 hours or more.');
            return false;
        }

        axiosInstance.post(`${process.env.REACT_APP_API_URL}/submit_timelog`, data)
            .then(response => {
                toast.success(response.data.message);
                reset();
                fetchTimeLogs();
            })
            .catch(error => {
                toast.error(error);
                console.error('Error submitting time log', error);
            });
    }
   

    return(
        <>
            <div className="content container-fluid">
                <div className="page-header">
                    <div className="row align-items-center">
                        <div className="col">
                            <h3 className="page-title">Time Log</h3>
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/dashboard">Dashboard</Link></li>
                                <li className="breadcrumb-item active">Time Log</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="card">
                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-12 mb-2" align="right">
                                <b>Total :</b>  {totalTime ?? 0} { totalTime > 1 ? 'Hours' : 'Hour'}
                            </div>

                            <div className="col-md-12">
                                <div className="table-responsive">
                                    <table className="table custom-table">
                                        <thead className="table-secondary">
                                            <tr>
                                                <th>Channel</th>
                                                <th>Client</th>
                                                <th>Project</th>
                                                <th>Meter Name</th>
                                                <th>Date</th>
                                                <th>Billable Hours</th>
                                                <th>Non-Billable Hours</th>
                                                <th>Total Hours</th>
                                                <th className="text-end">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                timelogs.length > 0 ? (
                                                    timelogs.map((timelog) => (
                                                            <tr className={timelog.deleted_at ? 'tableDanger' : ''} key={timelog.id}>
                                                                <td className={timelog.deleted_at ? 'text-danger' : ''}>{timelog.channel || ""}</td>
                                                                <td>{timelog.client || ""}</td>
                                                                <td>{timelog.project || ""}</td>
                                                                <td>{timelog.meter || "N/A"}</td>
                                                                <td>{timelog.time_log_date || ""}</td>
                                                                <td>{timelog.billable_time || "00:00" }</td>
                                                                <td>{timelog.nonbillable_time || "00:00" }</td>
                                                                <td>{timelog.time_spend || "00.00" }</td>
                                                                <td className="text-end">
                                                                    <div className="dropdown dropdown-action">
                                                                        <Link to="#" className="action-icon dropdown-toggle"
                                                                            data-bs-toggle="dropdown" aria-expanded="false"
                                                                                onClick={() => {
                                                                                    setTimeLogId(`${timelog.id}`);
                                                                                }} >
                                                                                <i className="material-icons">more_vert</i></Link>
                                                                        <div className="dropdown-menu dropdown-menu-right">
                                                                            <Link className="dropdown-item" to="#" data-bs-toggle="modal"
                                                                                data-bs-target={`#edit_timelog_${timelog.id}`}>
                                                                                    <i className="fa-solid fa-pencil m-r-5"></i> Edit Timelog</Link>

                                                                            {!timelog.deleted_at &&
                                                                                <DeleteComponent 
                                                                                    url = "delete_timelogs"
                                                                                    id = {timelog.id}
                                                                                    fetchData={fetchTimeLogs} />
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="9">No records found</td>
                                                    </tr>
                                                ) 
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                
                        {/* FINAL SUBMISSION OF TIMELOG */}
                        {timelogs.length > 0 && 
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <div className="row mt-4">
                                    <div className="col-md-6">
                                        <div className="input-block mb-3">                                                                
                                            <div className="checkbox">
                                                <label className="col-form-label">
                                                    Complete and Verify &nbsp;&nbsp;&nbsp;&nbsp;
                                                    <input type="checkbox" className="mt-2" value="1" {...register('is_submitted')}/>
                                                </label>
                                            </div>
                                            <div className="text-sm text-danger">
                                                {errors.is_submitted && <p>{errors.is_submitted.message}</p>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="">
                                    <button type="submit" className="btn btn-primary">SUBMIT</button>
                                </div>
                            </form>
                        }
                    </div>
                </div>                    
            </div>

            <EditTimeLog list={fetchTimeLogs} timelogId={timelogId} />
        </>
    );
}

export default TimeLog